import React from 'react';
import { useTranslation } from 'react-i18next';
import {Stack, CompoundButton } from '@fluentui/react/lib';
const ViewSelection:React.FC<{setView:React.Dispatch<React.SetStateAction<string>>}> = (props) => {
    const {t} = useTranslation();
    return (
        <>
        <div className="gemu-rs-view-selection-container">
            <Stack horizontal tokens={{childrenGap:20}}>
                <CompoundButton secondaryText={t('labels.selectStandardViewSubText')} onClick={() =>props.setView('standard')}>
                Standard
                </CompoundButton>
                <CompoundButton secondaryText={t('labels.selectExpertViewSubText')} onClick={() =>props.setView('classic')}>
                    Expert
                </CompoundButton>
            </Stack>
        </div>
        </>
    )
}

export default ViewSelection;